import { jsx as _jsx } from "react/jsx-runtime";
import { withBaseIcon } from '../src/Icons.utils';
export const AlignJustifyLine = (props) => withBaseIcon(_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", role: "img", children: _jsx("path", { d: "M3 21L21 21M3 15L21 15M3 9.00001L21 9.00002M3 3.00002H21", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), props);
AlignJustifyLine.iconName = 'align-justify';
AlignJustifyLine.displayName = 'AlignJustifyLine';
export default AlignJustifyLine;
